import { render, staticRenderFns } from "./CustomerActivityDispatchable.vue?vue&type=template&id=5c15675a&"
import script from "./CustomerActivityDispatchable.vue?vue&type=script&lang=js&"
export * from "./CustomerActivityDispatchable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports